import type {ReactNode} from 'react';
import {Stack, TextField} from '@wellstone-solutions/web';
import type {Choice} from '../../NoteForm';
import {ChecklistSection, useNoteForm} from '../../NoteForm';
import type {
  ChecklistField,
  ContactNoteAction,
  ContactNoteState,
} from '../state';

type NoteField = 'objectiveReason' | 'responseOutcome' | 'followUpPlan';

type ChecklistNoteSectionProps = {
  label: string;
  options: readonly Choice[];
  field: ChecklistField;
  noteField: NoteField;
  noteLabel: string;
  children?: ReactNode;
};

export const ChecklistNoteSection = ({
  label,
  options,
  field,
  noteField,
  noteLabel,
  children,
}: ChecklistNoteSectionProps) => {
  const {state, dispatch} = useNoteForm<ContactNoteState, ContactNoteAction>();

  return (
    <Stack spacing={2}>
      <ChecklistSection
        required
        label={label}
        options={options}
        value={state[field]}
        onToggle={(key) => dispatch({type: 'toggle', field, key})}
        onOtherChange={(value) => dispatch({type: 'setOther', field, value})}
      />
      <TextField
        multiline
        minRows={2}
        label={noteLabel}
        value={state[noteField]}
        onChange={(event) =>
          dispatch({type: 'set', field: noteField, value: event.target.value})
        }
      />
      {children}
    </Stack>
  );
};
